"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _GuidedImageStep = _interopRequireDefault(require("./GuidedImageStep"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var GuidedImage = function GuidedImage(_ref) {
  var imageUrl = _ref.imageUrl,
      steps = _ref.steps,
      className = _ref.className,
      otherProps = _ref.otherProps;
  return /*#__PURE__*/_react.default.createElement(ImageWrapper, _extends({
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement("img", {
    src: imageUrl,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement(StepsWrapper, null, steps.map(function (step, i) {
    return /*#__PURE__*/_react.default.createElement(_GuidedImageStep.default, {
      key: i,
      offsetTop: step.offsetTop,
      offsetLeft: step.offsetLeft,
      content: step.content
    }, i + 1);
  })));
};

var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "ImageWrapper"
})(["width:100%;position:relative;> img{max-width:100%;}"]);

var StepsWrapper = _styledComponents.default.div.withConfig({
  displayName: "StepsWrapper"
})(["position:absolute;top:0;right:0;bottom:0;left:0;"]);

GuidedImage.propTypes = {
  /** The URL of the image to be displayed. */
  imageUrl: _propTypes.string.isRequired,

  /** An array of steps to be displayed on top of the image. */
  steps: _propTypes.array.isRequired,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra prop to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = GuidedImage;
exports.default = _default;